import createIcon from '../../createIcon';

/**
 * @component @name Difference
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAyM0g0LjVDMy40IDIzIDIuNSAyMi4xIDIuNSAyMVY3SDQuNVYyMUgxOC41VjIzWk0xNS41IDFIOC41QzcuNCAxIDYuNTEgMS45IDYuNTEgM0w2LjUgMTdDNi41IDE4LjEgNy4zOSAxOSA4LjQ5IDE5SDE5LjVDMjAuNiAxOSAyMS41IDE4LjEgMjEuNSAxN1Y3TDE1LjUgMVpNMTcgMTVIMTFWMTNIMTdWMTVaTTE3IDlIMTVWMTFIMTNWOUgxMVY3SDEzVjVIMTVWN0gxN1Y5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Difference = createIcon('Difference', [
  [
    'path',
    {
      d: 'M18.5 23H4.5C3.4 23 2.5 22.1 2.5 21V7H4.5V21H18.5V23ZM15.5 1H8.5C7.4 1 6.51 1.9 6.51 3L6.5 17C6.5 18.1 7.39 19 8.49 19H19.5C20.6 19 21.5 18.1 21.5 17V7L15.5 1ZM17 15H11V13H17V15ZM17 9H15V11H13V9H11V7H13V5H15V7H17V9Z',
      key: 'g4sy2e',
    },
  ],
]);

export default Difference;
